import React, { useEffect, useState } from 'react';
import './style.scoped.css';
import Button from 'src/components/Button';
import PolicyModal from 'src/components/PolicyModal';
import ColorPink from 'src/assets/Color_Pink.svg';
import ColorBlue from 'src/assets/Color_Blue.svg';
import Policy from 'src/models/Policy';
import { FunctionCode, PolicyStatus } from 'src/constants';
import { formatMoney, removeLeadingZeros } from 'src/utils';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import PopupService from 'src/utils/PopupService';
import paymentSt, { PaymentStore } from 'src/stores/PaymentStore';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import CopyIcon from 'src/assets/CopyIcon.png';

interface PolicyCardObserverProps {
  policy: Policy;
  showArrowIcon?: boolean;
  initShowDetail?: boolean;
  children?: React.ReactNode;
  buttonType?: string;
  showBorder?: boolean;
  details?: string[],
  paymentStore?: PaymentStore,
}

const showSuccessMessage = (content) => {
  toast(<div className='text-center text-base font-bold text-onSurface'>
    {content}
  </div>, {
    autoClose: 3000,
    // hideProgressBar: true,
    position: 'top-center',
    closeButton: ({ closeToast }) => null,
    bodyClassName: 'policy__body-copied-policy-number',
    className: 'policy__copied-policy-number'
  });
}

const PolicyCardObserver = observer((props : PolicyCardObserverProps) => {
  const { 
    policy = {}, 
    showArrowIcon = true, 
    initShowDetail = false, 
    buttonType = "manage_policy",
    showBorder = true,
    details = [],
    paymentStore
  } = props;
  const { t } = useTranslation();
  const history = useHistory();
  const [showDetail, setShowDetail] = useState(false);
  const [showModal, setShowModal] = useState(false);
  
  useEffect(() => {
    if(!showArrowIcon && initShowDetail){
      setShowDetail(true);
    }
  }, [showArrowIcon, initShowDetail]);

  useEffect(() => {
    return () => {
      toast.dismiss();
    }
  }, []);

  const _handleClickButton = () => {
    switch(buttonType){
      case "manage_policy": {
        let functions = policy.function.filter(func => func != FunctionCode.TOPUP);
        if(functions.length == 0 || functions.includes(FunctionCode.NOT_PERMISSION)){
          PopupService.instance.current.open({
            visible: true,
            title: t('notification'),
            content: t('msg_11'),
            okTitle: t('close'),
            onOk: () => {
              PopupService.instance.current.close();
            },
            showIcon: false,
          });
        }else{
          setShowModal(!showModal)
        }
        break;
      }
      case "payment": {
        paymentStore.getPeriodicPolicyPayment({ policyNum: policy.policyNum, bgIndex: policy.bgIndex, history });
        break;
      }
    }
  };

  return (
    <div className="wapper_card mb-4">
      <div className="item">
        <div className={`item-view ${policy.policyStatusId == PolicyStatus.Active ? 'cl-pink' : 'cl-blue'} p-10ct`}>
          <div className="layout-top">
            <div className="lf">
            </div>
            <div className="rf">
              <div className="title pb-5px">
                {policy.productName}
              </div>
              <div className="number-phone">
                {removeLeadingZeros(policy.policyNum)}{' '}
                <img src={CopyIcon} onClick={() => {
                  const el = document.createElement('textarea');
                  el.value = policy.policyNum;
                  document.body.appendChild(el);
                  el.select();
                  document.execCommand('copy');
                  document.body.removeChild(el);
                  showSuccessMessage(t('copied'));
                }}/>
              </div>
              {policy.policyStatusId == PolicyStatus.Active && <div className="active-card cl-green d-inline-block">
                {t('active')}
              </div>}
              {policy.policyStatusId == PolicyStatus.Lapsed &&
              <div className="disconnect-card cl-gray d-inline-block">
                {t('lapsed')}
              </div>}
            </div>
          </div>
          <div className="layout-buttom">
            <div className="lf">
              <div className="title-buy">
                {t('insurance_buyer')}
              </div>
              <div className="name-buy">
                {policy.policyHolderName}
              </div>
            </div>
            <div className="rf">
              <div className="logo-ct">
              </div>
            </div>
          </div>
          {showArrowIcon && <div className="btn-detail">
            <button className='icon-btn' onClick={() => setShowDetail(!showDetail)}>
                <i className={'arrow-ct' + (!showDetail ? ' down-ct' : ' up-ct') }></i>
            </button>
          </div>}
          <div className="bg-cl-ping">
            <img src={policy.policyStatusId == PolicyStatus.Active ? ColorPink : ColorBlue} alt="" className='w-100'/>
          </div>
        </div>
        {showDetail &&
          <div className="show-detail">
            <div className={"show-detail-top border border-line" + (initShowDetail && showBorder ? " border-radius-bottom mb-4" : "")}>
              {details.includes("assuredName") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('insurancer')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.assuredName}
                  </div>
              </div>}

              {details.includes("sumAssured") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('insurrance_amount')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {formatMoney(policy.sumAssured)}{" "}{policy.currency}
                  </div>
              </div>}

              {details.includes("polStatrtDat") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('policy_start_date')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.polStatrtDat}
                  </div>
              </div>}

              {details.includes("policyTerm") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('insurance_period')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.policyTerm ? policy.policyTerm + ' ' + t('year') : ''}
                  </div>
              </div>}

              {details.includes("payFrequency") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('term_fee')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.payFrequency}
                  </div>
              </div>}

              {details.includes("periodicPremium") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('periodic')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {formatMoney(policy.periodicPremium)}{" "}{policy.currency}
                  </div>
              </div>}

              {details.includes("agentName") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('agent_name')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.agentName}
                  </div>
              </div>}

              {details.includes("agentPhone") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('agent_phone')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {policy.agentPhone}
                  </div>
              </div>}

              {details.includes("agentCode") && <div className="flex flex-row pb-6 grid grid-cols-2">
                  <div className="flex-1 bodyText2 text-onSurfaceVariant">
                    {t('agent_code')}
                  </div>
                  <div className="smallTitle2 text-right">
                    {removeLeadingZeros(policy.agentCode)}
                  </div>
              </div>}
            </div>
              {showArrowIcon && <div className={"show-detail-bottom btn-submit" + (showBorder ? " border border-line" : "")}>
                <Button
                  text={t(buttonType)}
                  onClick={_handleClickButton}
                  extraClassName={'w-full'}
                />
              </div>}
          </div>
        }
      </div>
      {showModal && <PolicyModal policy={policy} show={showModal} onClose={() => setShowModal(false)} />}
    </div>
  );
});

const PolicyCard = (props) => <PolicyCardObserver {...props} paymentStore={paymentSt} />;
export default PolicyCard;
